/**
 * @fileOverview Loads city data and passes it to child component.
 * Loads the following info and passes down as props
 * - brandAmbassadors
 */

import React, { useState, useEffect } from 'react'
import { getCityBrandAmbassadors } from './../../../Module/graphQL'
import {
  STATUS_BLOCKED,
  BRAND_AMBASSADOR_STATUS_ENUM,
} from '../../../shared/constants'
const validateResponse = res => {
  if (res['errorMessage']) {
    throw new Error(res['errorMessage'])
  }
  if (res.errors && res.errors[0]) {
    throw new Error(res.errors[0].message)
  }
}

const getCityBrandAmbassadorsCombined = async cityId => {
  const [
    activeBrandAmbassadors,
    blockedWithInventoryBrandAmbassadors,
    blockedWithMissionsBrandAmbassadors,
  ] = await Promise.all([
    (await getCityBrandAmbassadors({
      cityId,
      statuses: [BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE],
    })).json(),
    (await getCityBrandAmbassadors({
      cityId,
      hasInventory: true,
      statuses: [BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED],
    })).json(),
    (await getCityBrandAmbassadors({
      cityId,
      hasMissionsBooked: true,
      statuses: [BRAND_AMBASSADOR_STATUS_ENUM.BLOCKED],
    })).json(),
  ])
  validateResponse(activeBrandAmbassadors)
  validateResponse(blockedWithInventoryBrandAmbassadors)
  validateResponse(blockedWithMissionsBrandAmbassadors)

  return [
    ...activeBrandAmbassadors.data.city.brandAmbassadors.edges,
    ...blockedWithInventoryBrandAmbassadors.data.city.brandAmbassadors.edges,
    ...blockedWithMissionsBrandAmbassadors.data.city.brandAmbassadors.edges,
  ]
}
const BrandAmbassadorData = props => {
  const { children, cityId, ...otherProps } = props

  const [data, setData] = useState({
    brandAmbassadors: undefined,
  })

  // Will be set to true once the filter info has been requested
  const [requestedFilterInfo, setRequestedFilterInfo] = useState(false)

  // This fetches all the data we need for the global planning filters. For
  // example we need to know all the campaigns and clients that operate in the
  // current city
  useEffect(() => {
    if (requestedFilterInfo) return
    setRequestedFilterInfo(true)
    ;(async () => {
      const brandAmbassadorsRaw = await getCityBrandAmbassadorsCombined(cityId)
      setData({
        brandAmbassadors: brandAmbassadorsRaw.map(({ node }) => ({
          id: node.id,
          name: node.firstName + ' ' + node.lastName,
          flag: node.status == STATUS_BLOCKED,
        })),
      })
    })()
  })

  return React.cloneElement(children, {
    ...otherProps,
    cityId,
    ...data,
  })
}

export default BrandAmbassadorData



// WEBPACK FOOTER //
// ./src/Containers/City/DataHOCs/BrandAmbassadors.js